const apiUrl = 'https://api-dev.healshealthcare.com/api/v1'
// const apiUrl = 'https://api.healshealthcare.com/api/v1'



export default {
  apiUrl,
}
